module.exports = __webpack_public_path__ + "static/media/product4.7bbda46a.png";